<div class="exception-body error">
    <img src="assets/layout/images/logo-white.svg" alt="diamond-layout" class="logo">

    <div class="exception-content">
        <div class="exception-title">{{'ERROR'|translate}}</div>
        <div class="exception-detail">{{'SOMETHING_WENT_WRIONG'|translate}}</div>
        <a [routerLink]="['/']">{{'GO_TO_DASHBOARD'|translate}}</a>
    </div>
</div>
